import CompaniesPublication from "./CompaniesPublication";

export default CompaniesPublication;
